import fetch from "../helpers/fetch";

const getInstitutionIdTypes = () =>
  fetch(`/api/institution-id-types/all`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include'
  })
    .then(res => res)
    .catch(error => {
      throw error;
    });

const postInstitutionIdType = newInstitutionIdType =>
  fetch(`/api/institution-id-type/create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(newInstitutionIdType)
  })
    .then(res => res)
    .catch(error => {
      throw error;
    });

const putInstitutionIdType = ({ uuid, ...updates }) =>
  fetch(`/api/institution-id-type/${uuid}/update`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(updates)
  })
    .then(res => res)
    .catch(error => {
      throw error;
    });

const deleteInstitutionIdType = uuid =>
  fetch(`/api/institution-id-type/${uuid}/delete`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include'
  })
    .then(res => res)
    .catch(error => {
      throw error;
    });

export {
  getInstitutionIdTypes,
  postInstitutionIdType,
  putInstitutionIdType,
  deleteInstitutionIdType
};
